import { render, staticRenderFns } from "./accountPanel.vue?vue&type=template&id=5cc84779&scoped=true&"
import script from "./accountPanel.vue?vue&type=script&lang=js&"
export * from "./accountPanel.vue?vue&type=script&lang=js&"
import style0 from "./accountPanel.vue?vue&type=style&index=0&id=5cc84779&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc84779",
  null
  
)

export default component.exports